import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';

import { AuthenticationService } from '../_services/authentification.service';
import { ZeroService } from '../_services/zero/zero.service';
import { environment } from 'src/environments/environment';
import { SessionService } from '../_services/session.service';

@Component({
  selector: 'app-login-forge',
  templateUrl: './login-forge.component.html'
})
export class LoginForgeComponent implements OnInit {
  // seccion header
  public nombreUsuario: string = "Nombre del usuario";
  public mailUsuario: string = "mail@example.com.mx";
  public rol: string = "rol";
  public user : string = "user";


  constructor(private router: Router,
    private authenticationService: AuthenticationService,
    private zero: ZeroService,
    private session: SessionService) { 
     
      this.obtieneUsuario();
      if (this.user = "ejecutor") {
          this.router.navigate(["busquedaEjecutor"]);
      }
  }

  ngOnInit() {}

  obtieneUsuario(){
    var scope = this;
    this.zero.request({
        uri: environment.uris.comunes.usuario,
        isSingleResponse: false,
        method: "GET",
        ok: function (response) {
          console.log(response);
            if(response){
                console.log(response);
                scope.nombreUsuario = response.nombre;
                scope.mailUsuario = response.mail;
                scope.rol = response.rol;
                scope.user = response.user;
                // scope.sessionService.saveInSession("user",response.user);
            }    
        }
    });
}

onSubmit() {}
    
}
